import { useEffect, useState, useContext } from 'react';
import { SearchContext } from '../../../App';
import { appendHomeSearchParams } from '../../../util/activitySearchOptions';
import classes from "./NavBarSearch.module.css";
import { useNavigate } from 'react-router-dom';

import SearchOptions from './SearchOptions';

const NavBarSearch = ({ token }) => {
    const navigate = useNavigate();

    const {
        searchFields,
        setSearchFields,
        options,
        setOptions,
        activeInput,
        setActiveInput,
        setIsPhoneSearch,
        updateSearchField,
        filteredActivities,
        filteredLocations,
        setFilteredLocations,
        selectLocation
    } = useContext(SearchContext);

    const [placeholders, setPlaceholders] = useState({
        studio: "Studio suchen",
        location: "Standort",
        date: "Datum u. Uhrzeit"
    });
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    const handleChange = (input, event) => {
        const value = event.target.value;
        setSearchFields((prevFields) => ({
          ...prevFields,
          [input]: value
        }));
        updateSearchField(input, value);
    };

    const handleBlur = (input, event) => {
        if (input === 'activity' && !searchFields.activity) {
          setSearchFields((prevFields) => ({
            ...prevFields,
            activity: ''
          }));
        }
        if (input === 'location' && !searchFields.location) {
          setSearchFields((prevFields) => ({
            ...prevFields,
            location: ''
          }));
        }
        if (input === 'date') {
          event.target.type = 'text';
          if (!searchFields.date) {
            setSearchFields((prevFields) => ({
              ...prevFields,
              date: ''
            }));
          }
        }
    };  

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
            if ((window.innerWidth < 920) || (token && window.innerWidth < 1039)) {
                setPlaceholders({
                    studio: "Studio",
                    location: "Standort",
                    date: "Datum"
                });
                
            } else {
                setPlaceholders({
                    studio: "Studio suchen",
                    location: "Standort",
                    date: "Datum u. Uhrzeit"
                });
            }
        };

        window.addEventListener('resize', handleResize);

        handleResize();

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [token]);

    const handleClickOutside = (event) => {
        const isInsideInputs = event.target.closest(`.${classes.inputStudios}`) ||
                              event.target.closest(`.${classes.inputLocation}`) 
                            //   ||
                            //   event.target.closest(`.${classes.inputDate}`);
        
        const isOutsideResultsContainer = !event.target.closest(".SearchOptions_resultsContainer__M6hDA");
      
        if (!isInsideInputs && isOutsideResultsContainer) {
            setActiveInput(null);
        }
    };
    
    const handleSearchResults = () => {
        if (searchFields.activity || searchFields.location) {
            const queryParams = appendHomeSearchParams(new URLSearchParams(), {
              activity: searchFields.activity,
              location: searchFields.location,
              locationPlaceId: searchFields.locationPlaceId,
              date: searchFields.date,
            }).toString();
            navigate(`/search?${queryParams}`, { replace: false });
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
          document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [handleClickOutside]);

  return (
    <div className={`${classes.searchContainer} ${token && window.innerWidth < 1039 ? classes.narrowSearch : ''}`}>
        <div className={classes.searchIconContainer}>
            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                <path d="M6.97883 13.475C8.482 13.475 9.861 12.9287 10.9297 12.022L15.7322 16.7093L15.8044 16.7797L15.8742 16.7069L16.4921 16.0624L16.5607 15.9909L16.4898 15.9217L11.6996 11.2443C12.5972 10.1647 13.1377 8.77187 13.1377 7.25389C13.1377 3.82318 10.3772 1.03281 6.97883 1.03281C3.58049 1.03281 0.819922 3.82318 0.819922 7.25389C0.819922 10.6846 3.58049 13.475 6.97883 13.475ZM7.07883 12.3819V12.3778H6.97883C4.18318 12.3778 1.90549 10.0782 1.90549 7.25137C1.90549 4.42465 4.18305 2.13 6.97883 2.13C9.77448 2.13 12.0522 4.42958 12.0522 7.25642C12.0522 10.0495 9.82859 12.3278 7.07883 12.3819Z" fill="#DDE1E5" stroke="#DDE1E5" strokeWidth="0.2"/>
            </svg>
        </div>
        <input
            className={`${classes.inputStudios} slimRegularLargeSearchBar ${token && window.innerWidth < 1039 ? classes.narrowInput : ''}`}
            type="text"
            value={searchFields.activity || ""}
            placeholder={placeholders.studio}
            onClick={() => activeInput !== 'activity' && setActiveInput('activity')}
            onChange={(event) => handleChange('activity', event)}
            onBlur={(event) => handleBlur('activity', event)}
        />
        <div className={classes.smallLine}></div>
        <input
            className={`${classes.inputLocation} slimRegularLargeSearchBar ${token && window.innerWidth < 1039 ? classes.narrowInputLocation : ''}`}
            type="text"
            value={searchFields.location || ""}
            placeholder={placeholders.location}
            onClick={() => activeInput !== 'location' && setActiveInput('location')}
            onChange={(event) => handleChange('location', event)}
            onBlur={(event) => handleBlur('location', event)}
        />
        {/* <div className={classes.smallLine}></div> */}
        {/* <input
            className={`${classes.inputDate} slimRegularLargeSearchBar ${token && window.innerWidth < 1039 ? classes.narrowInputDate : ''}`}
            type="text"
            value={searchFields.date || ""}
            placeholder={placeholders.date}
            onClick={() => activeInput !== 'date' && setActiveInput('date')}
            onChange={(event) => handleChange('date', event)}
            onBlur={(event) => handleBlur('date', event)}
        /> */}
        <div className={classes.searchIcon} onClick={handleSearchResults}>
            <svg xmlns="http://www.w3.org/2000/svg" width="31" height="32" viewBox="0 0 31 32" fill="none">
                <circle cx="15.6699" cy="15.8857" r="15.25" fill="#101010"/>
                <path fillRule="evenodd" clipRule="evenodd" d="M16.5142 11.126L20.72 15.401C20.8494 15.5325 20.9944 15.6941 21.1602 15.8772C20.9656 16.075 20.8488 16.2201 20.72 16.351L16.5142 20.626C16.2438 20.3511 16.2979 20.4206 16.0398 20.1582C15.7817 19.8959 15.8605 19.9614 15.5796 19.676L18.6572 16.5477H10.1602V15.2042H18.6572L15.5796 12.076L16.0443 11.5983L16.5142 11.126Z" fill="#DDE1E5"/>
            </svg>
        </div>
        {activeInput && (
            <SearchContext.Provider
                value={{
                searchFields,
                setSearchFields,
                options,
                setOptions,
                activeInput,
                setActiveInput,
                setIsPhoneSearch,
                updateSearchField,
                filteredActivities,
                filteredLocations,
                selectLocation
                }}
            >
                <SearchOptions />
            </SearchContext.Provider>
        )}
    </div>
  );
};

export default NavBarSearch;
